"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "buildRoutes", {
    enumerable: true,
    get: function() {
        return buildRoutes;
    }
});
const buildRoutes = (obj)=>{
    return obj;
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvdHlwZXMudHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHR5cGUgUm91dGVPcHRpb25zID0ge1xuICBwYXRoOiBzdHJpbmc7XG59O1xuXG50eXBlIFJvdXRlVGFibGU8VD4gPSB7XG4gIFtLIGluIGtleW9mIFRdOiBSb3V0ZU9wdGlvbnM7XG59O1xuXG5leHBvcnQgdHlwZSBVUkxQYXJhbXMgPSB7XG4gIFt4OiBzdHJpbmddOiBzdHJpbmcgfCB1bmRlZmluZWQ7XG59O1xuXG5leHBvcnQgY29uc3QgYnVpbGRSb3V0ZXMgPSA8VCBleHRlbmRzIFJvdXRlVGFibGU8VD4+KG9iajogVCkgPT4ge1xuICByZXR1cm4gb2JqO1xufTtcbiJdLCJuYW1lcyI6WyJidWlsZFJvdXRlcyIsIm9iaiJdLCJtYXBwaW5ncyI6Ijs7OzsrQkFZYUE7OztlQUFBQTs7O0FBQU4sTUFBTUEsY0FBYyxDQUEwQkM7SUFDbkQsT0FBT0E7QUFDVCJ9